import {
	departmentsOptionMobileSX,
	departmentsContentContainerSX,
} from '@/components/content/Header/styles/departmentsOption';
import { Box, SwipeableDrawer } from '@mui/material';
import { FC, ReactNode, type MouseEvent } from 'react';
interface DepartmentsOptionMobileProps {
	children: ReactNode;
	isOpen: boolean;
	handleClose: () => void;
	openDrawer: (event: MouseEvent<HTMLElement>) => void;
}

export const DepartmentsOptionMobile: FC<DepartmentsOptionMobileProps> = ({
	children,
	isOpen,
	handleClose,
	openDrawer,
}) => (
	<SwipeableDrawer
		open={Boolean(isOpen)}
		onClose={handleClose}
		onOpen={openDrawer}
		elevation={4}
		anchor="bottom"
		sx={departmentsOptionMobileSX}
	>
		<Box sx={departmentsContentContainerSX}>{children}</Box>
	</SwipeableDrawer>
);
